import { Hero } from '@/components/Hero';
import { HowItWorks } from '@/components/HowItWorks';
import { Features } from '@/components/Features';
import { ActiveQuests } from '@/components/ActiveQuests';
import { Rewards } from '@/components/Rewards';
import { Credits } from '@/components/Credits';
import { FAQ } from '@/components/FAQ';
import { CTAFinal } from '@/components/CTAFinal';
import { RecentTimeline } from '@/components/RecentTimeline';

export default function Landing() {
  return (
    <>
      <Hero />
      <RecentTimeline />
      <HowItWorks />
      <ActiveQuests />
      <Rewards />
      <Features />
      <Credits />
      <FAQ />
      <CTAFinal />
    </>
  );
}
